import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
  CalendarListState,
  SetFilterPayload,
  EditCalendarPayload,
  CreateCalendarPayload,
  CalendarKeysPayload,
  CopyCalendarOpenPayload,
  CopyCalendarSetOriginalPayload,
  CopyCalendarPayload,
} from './calendarListTypes';

const initialState: CalendarListState = {
  selectionMode: false,
  error: false,
  filters: {
    name: '',
    deletedCalendars: false,
  },
  copyCalendar: {
    status: 'CLOSED',
    item: null, // the item clicked in the list
    originalCalendar: null, // the item to keep when switching schools
  },
};

const calendarListState = createSlice({
  name: 'calendarList',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterPayload>) => {
      const { property, value } = action.payload;
      (state.filters[property] as typeof value) = value;
    },
    removeAllFilters: (state) => {
      state.filters = initialState.filters;
    },
    setSelectionMode: (state, action: PayloadAction<boolean>) => {
      state.selectionMode = !!action.payload;
    },
    editCalendar: (_state, _action: PayloadAction<EditCalendarPayload>) => {},
    createCalendar: (_state, _action: PayloadAction<CreateCalendarPayload>) => {},
    archiveCalendar: (_state, _action: PayloadAction<CalendarKeysPayload>) => {},
    deleteCalendar: (_state, _action: PayloadAction<CalendarKeysPayload>) => {},
    undeleteCalendar: (_state, _action: PayloadAction<CalendarKeysPayload>) => {},
    copyCalendarOpen: (state, action: PayloadAction<CopyCalendarOpenPayload>) => {
      state.copyCalendar.item = action.payload.item;
      state.copyCalendar.status = 'OPEN';
    },
    copyCalendarSetOriginalCalendar: (
      state,
      action: PayloadAction<CopyCalendarSetOriginalPayload>,
    ) => {
      state.copyCalendar.originalCalendar = action.payload.originalCalendar;
    },
    copyCalendar: (state, _action: PayloadAction<CopyCalendarPayload>) => {
      state.copyCalendar.status = 'SAVING';
    },
    copyCalendarClose: (state) => {
      state.copyCalendar.item = null;
      state.copyCalendar.originalCalendar = null;
      state.copyCalendar.status = 'CLOSED';
    },
  },
});

export const calendarListActions = calendarListState.actions;
export const {
  setFilter,
  removeAllFilters,
  setSelectionMode,
  editCalendar,
  createCalendar,
  archiveCalendar,
  deleteCalendar,
  undeleteCalendar,
  copyCalendar,
  copyCalendarClose,
  copyCalendarSetOriginalCalendar,
  copyCalendarOpen,
} = calendarListState.actions;

export default calendarListState;
